// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"cddccd89","498":"a5a6c897","513":"9f6cd283","787":"336b8bd6"}[chunkId] + ".chunk.js";
};